import { observable } from 'mobx';
import { WebGivingPage } from '../index';
import { FormField } from '../../components/form-field';
import { ValidationState, validateFields } from '../../validation/view-model-validator';
import { createRulesFromMetadata } from '../../validation/validation-rules';
import { ModelMetadata } from '../../webgiving-generated';
import { AchPaymentMethodViewModel } from '../page-payment-method/ach-payment-method-view-model';
import { WebGivingPageViewModelBase } from '../page-view-model-base';

export class PageConfirmBankAccountViewModel extends WebGivingPageViewModelBase {
	readonly type: WebGivingPage.ConfirmBankAccount = WebGivingPage.ConfirmBankAccount;
	accountNumberConfirm: FormField<string>;

	@observable
	validationState?: ValidationState;

	validate(): ValidationState {
		return validateFields(this, 'Please enter valid details');
	}

	constructor(public achModel: AchPaymentMethodViewModel, public bankName: string) {
		super();
		this.accountNumberConfirm = new FormField<string>('', createRulesFromMetadata(ModelMetadata.ConfirmACHAccountRequest.AccountNumber));
	}
}
